<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Transaction Summary Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getTransactionSummary('N', 'N')"
            >
              {{ $t("fetch") }}
            
            </button>
          </div>

          <div
            v-if="transactionSummaryRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getTransactionSummary('Y', 'N')"
              title="Download as Excel"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getTransactionSummary('N', 'Y')"
              title="Download as PDF"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Cinema Name</th>
            <th>Payment Mode</th>
            <th>Month</th>
            <th>Total Transactions</th>
            <!-- <th>Total Admits</th>
            <th>Total Gross Amount</th> -->
          </thead>
          <tbody v-if="transactionSummaryRecords.length > 0">
            <tr
              v-for="(transactionObj,
              transactionIndex) in transactionSummaryRecords"
              :key="transactionIndex"
            >
              <td class="text-left">{{ transactionObj.cinema_name }}</td>
              <td class="text-left">{{ transactionObj.payment_source }}</td>
              <td class="text-left">{{ transactionObj.month }}</td>
              <td class="text-right">{{
                transactionObj.total_transactions
              }}</td>
              <!-- <td class="text-right">{{ transactionObj.total_admits }}</td>
              <td class="text-right">{{
                currFormat(transactionObj.total_gross_amount)
              }}</td> -->
            </tr>
            <tr class="bg-lightgrey">
              <td class="text-left" colspan="3">Grand Total</td>
              <td class="text-right">{{ grandTotal.total_transactions }}</td>
              <!-- <td class="text-right">{{ grandTotal.total_admits }}</td>
              <td class="text-right">{{
                currFormat(grandTotal.total_gross_amount)
              }}</td> -->
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="15">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      transactionSummaryRecords: [],

      excelFilePath: "",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    const { cinema_id } = this.secureStore.get("USINFO");
    this.getCinemaList(cinema_id);
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onChangeDate(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function(cinema_id) {
      MasterService.GetCinemas({cine_id: cinema_id})
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            if(!cinema_id) {
              data.Records.unshift({ cine_id: 0, cine_name: "All Cinemas" });
            } 
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getTransactionSummary(isExcel = "N", isPdf = "N") {
      this.transactionSummaryRecords = [];

      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
      };
      ReportsService.GetTransactionSummary(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.transactionSummaryRecords = [...data.Records];
            this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/transactionSummaryReport.vue